import { CODE_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CODE_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case CODE_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case CODE_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
